import { dailyRemittancePdfReportService, DailyRemittanceReport, monthlyRemittancePdfReportService, MonthlyRemittanceReport } from '@shared/services/api/remittancesService';
import { ThunkAction } from 'redux-thunk';
import {
    REPORT_FAILURE,
    REPORT_REQUEST,
    REPORT_SUCCESS,
    ReportActionTypes,
    ReportState,
    reportSuccessMessage
} from './fileExportTypes';

export const reportRequest = (): ReportActionTypes => ({
    type: REPORT_REQUEST,
});

export const reportSuccess = (data: any): ReportActionTypes => ({
    type: REPORT_SUCCESS,
    payload: data,
});

export const reportFailure = (error: string): ReportActionTypes => ({
    type: REPORT_FAILURE,
    payload: error,
});

export interface RootState {
    correspondentRemittance: ReportState;
}

export const generateDailyPdfReport = (requestData: DailyRemittanceReport): ThunkAction<Promise<void>, RootState, unknown, ReportActionTypes> => {
    return async (dispatch) => {
        dispatch(reportRequest());
        try {
            const result = await dailyRemittancePdfReportService(requestData);
            dispatch(reportSuccess({ message: reportSuccessMessage, data: result }));
        } catch (err: any) {
            dispatch(reportFailure(err.message));
        }
    };
}

export const generateMonthlyPdfReport = (requestData: MonthlyRemittanceReport): ThunkAction<Promise<void>, RootState, unknown, ReportActionTypes> => {
    return async (dispatch) => {
        dispatch(reportRequest());
        try {
            const result = await monthlyRemittancePdfReportService(requestData);
            dispatch(reportSuccess({ message: reportSuccessMessage, data: result }));
        } catch (err: any) {
            dispatch(reportFailure(err.message));
        }
    };
}

export const resetReport = (): ThunkAction<Promise<void>, RootState, unknown, ReportActionTypes> => {
    return async (dispatch) => {
        const initialState: ReportState = {
            data: null,
            loading: false,
            error: null,
        };
        dispatch(reportRequest());
        dispatch(reportSuccess(initialState));
    };
}